import React, { useEffect, useState } from 'react';
import * as S from './AdBanner.styles';
import { initAdConfig } from '../../SEOContainer/Common/utils';

const AdBanner = (props) => {
  // const [showAd, toggleShowAd] = useState(true);

  const useViewCB = (e) => {
    // toggleShowAd(true);
  }

  const errorCB = (e) => {
    console.log("Ad Error callback")
    // toggleShowAd(false);
  }

  useEffect(() => {
    initAdConfig(useViewCB, errorCB);
  }, []);

  return (
    <S.Wrapper>
      <S.AdBannerWrapper>
        <mmtad data-cid={props.cid}></mmtad>
      </S.AdBannerWrapper>
    </S.Wrapper>
  );
};
export default AdBanner;
